(() => {
  if (window.semboniaSwatchFeedbackReady) return;
  window.semboniaSwatchFeedbackReady = true;
  const selector = '.sembonia-product-tabs .featured-product-swatch, .sembonia-collection-swatches .featured-product-swatch';
  // Swatch King owns PDP tooltips; custom card dots use the theme tooltip only.
  const tooltipSelector = selector;
  const warmed = new Set();
  const observed = new WeakSet();
  const tooltip = document.createElement('div');
  tooltip.className = 'sembonia-floating-swatch-tooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.id = 'sembonia-floating-swatch-tooltip';
  tooltip.hidden = true;
  document.body.append(tooltip);
  let active;
  function warm(swatch) {
    const src = swatch.dataset.swatchImage;
    if (!src || warmed.has(src)) return;
    warmed.add(src);
    const image = new Image();
    image.fetchPriority = 'low';
    image.src = src;
  }
  function hide() {
    active?.removeAttribute('aria-describedby');
    active = null;
    tooltip.hidden = true;
  }
  function show(swatch) {
    hide();
    active = swatch;
    warm(swatch);
    tooltip.textContent = swatch.getAttribute('orig-value') || swatch.getAttribute('aria-label') || '';
    tooltip.hidden = false;
    swatch.setAttribute('aria-describedby', tooltip.id);
    const rect = swatch.getBoundingClientRect();
    const box = tooltip.getBoundingClientRect();
    tooltip.style.left = `${Math.max(8, Math.min(innerWidth - box.width - 8, rect.left + rect.width / 2 - box.width / 2))}px`;
    tooltip.style.top = `${Math.max(8, rect.top - box.height - 8)}px`;
  }
  document.addEventListener('pointerover', event => {
    const swatch = event.target.closest(tooltipSelector);
    if (swatch) show(swatch);
  });
  document.addEventListener('focusin', event => {
    const swatch = event.target.closest(tooltipSelector);
    if (swatch) show(swatch);
  });
  document.addEventListener('pointerout', event => { if (active && !active.contains(event.relatedTarget)) hide(); });
  document.addEventListener('focusout', hide);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  window.addEventListener('scroll', hide, { passive:true, capture:true });
  window.addEventListener('resize', hide);
  // Capture at window precedes the collection's document-level click handler.
  window.addEventListener('click', event => {
    // Summary dots/counts must not select a variant or trigger the full-card link.
    const summary = event.target.closest('span.featured-product-swatch, .sembonia-swatch-more');
    if (summary && summary.closest('.sembonia-product-tabs, .sembonia-collection-swatches, .snc-swatches')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const swatch = event.target.closest(selector);
    if (!swatch || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const card = swatch.closest('.sparq-card, .product-card-wrapper');
    if (!card) return;
    // Use the visible native badge's anchor before it is hidden. Homepage cards
    // and Sparq cards have different containing blocks and internal padding.
    const nativeBadge = [...card.querySelectorAll('.product-label > span, .card__badge .badge')].find(item => item.getBoundingClientRect().width > 0);
    if (nativeBadge) {
      const outer = card.getBoundingClientRect();
      const rect = nativeBadge.getBoundingClientRect();
      card.dataset.semboniaBadgeTop = String(rect.top - outer.top);
      card.dataset.semboniaBadgeRight = String(outer.right - rect.right);
    }
    card.dataset.semboniaSelectedSoldOut = String(swatch.classList.contains('sold-out'));
    let badge = card.querySelector('.sembonia-selected-stock-badge');
    if (swatch.classList.contains('sold-out')) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sembonia-selected-stock-badge';
        badge.textContent = 'OUT OF STOCK';
        card.append(badge);
      }
      badge.style.top = `${card.dataset.semboniaBadgeTop || 20}px`;
      badge.style.right = `${card.dataset.semboniaBadgeRight || 20}px`;
    } else badge?.remove();
    card.querySelectorAll('.featured-product-swatch[aria-current]').forEach(item => item.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    hide();
  }, true);
  const observer = window.IntersectionObserver ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      // Warm only the first four colours of visible cards, not the entire catalogue.
      entry.target.querySelectorAll('.featured-product-swatch').forEach((swatch, index) => { if (index < 4) warm(swatch); });
      observer.unobserve(entry.target);
    });
  }, { rootMargin:'100px' }) : null;
  let queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.sembonia-product-tabs .featured-product-swatches, .sembonia-collection-swatches').forEach(row => {
      if (observed.has(row)) return;
      observed.add(row);
      observer?.observe(row);
    });
  }
  new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(scan); } }).observe(document.body, { childList:true, subtree:true });
  scan();
})();
